import store from "store";
import { Clear } from "reducers/LoginReducer";
const CLEAR = "sure-quote/Login/CLEAR";

export function Logout(){
  store.dispatch(Clear({ type: CLEAR, props: {} }));
  localStorage.clear();
  sessionStorage.clear();
}

export function GetUserToken(){
  let storeToken = store.getState().login.token;
  let localToken = localStorage.getItem("token");
  return storeToken && storeToken !== "" ? storeToken :  localToken && localToken !== "" ? localToken : "";
}

export function GetUserId(){
  let storeUserId = store.getState().login.userID;
  let localUserId = localStorage.getItem("id");
  return storeUserId && storeUserId !== "" ? storeUserId :  localUserId && localUserId !== "" ? localUserId : "";
}

export function GetUserKey(key){
  let storeKey = store.getState().login[key];
  let localKey = localStorage.getItem(key);
  return storeKey && storeKey !== "" ? storeKey :  localKey && localKey !== "" ? localKey : "";
}


// WEBPACK FOOTER //
// ./src/helpers/UserHelper.js